<template>
    <div class="container">
        <div class="head_card">
            <van-row class="top-row-container">
                <van-col span="5" class="avatar">
                    <img :src="avatarImg || defaultAvatar" />
                </van-col>
                <van-col span="17" class="detailsContainer">
                    <div style="margin-top: -10px;">
                        <div class="contact">{{ name }}
                            <div class="level">
                                <img src="@/assets/themeFour/vip_level.png" alt="">
                                <span class="img-text">{{ $t('vip.title') }} {{ currentLevel }}</span>
                            </div>
                        </div>
                        <div class="id">{{ $t('profile.id') }} : {{ id }}
                            <img src="@/assets/themeFour/copy-icon.png" alt="" @click="onCopyID(id)"
                                style="padding-left: 10px;width: 6%;">
                        </div>
                    </div>
                </van-col>
            </van-row>
            <van-row class="amount-row">
                <van-col span="12" class="balance-col">
                    {{ $t('home.balance') }}
                    <div class="value">
                        <span style="font-size: 20px;font-weight: bold;"> <span class="amount-sign">R$</span>{{
                            formatCurrency(balance) }} </span>
                        <img @click="refreshDetails" src="@/assets/themeFour/refresh.png" alt="" style="width: 8%;">
                    </div>
                </van-col>
                <van-col span="12" class="balance-col">
                    {{ $t('home.todayBonus') }}
                    <div class="value">
                        <span style="font-size: 20px;font-weight: 400;"> 0,00</span>
                    </div>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="12" class="deposit_btn">
                    <PrimaryButton :text="$t('common.deposite')" class="deposit-btn" textColor="#fff"
                        bgColor="rgb(0, 86, 85)" :icon="require('@/assets/themeFour/deposit.png')"
                        @onClick="onButtonClick('topup')" />
                </van-col>
                <van-col span="12" class="withdraw_btn">
                    <PrimaryButton :text="$t('common.sake')" class="withdraw-btn" textColor="#fff"
                        bgColor="rgb(0, 86, 85)" :icon="require('@/assets/themeFour/withdraw.png')"
                        @onClick="onButtonClick('withdraw')" />
                </van-col>
            </van-row>
        </div>
        <StatusPopup ref="statusRef" :content="$t('common.copied')" :isShowSuccess="true" />
        <CarteiraView ref="walletPopupRef" />
        <LoadingScreen ref="loadingRef" />
    </div>
</template>

<script setup lang="ts">
import PrimaryButton from '../../components/common/primaryButton.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { formatCurrency } from '@/utils/commonFunction';
import CarteiraView from '@/view/carteiraView/carteiraView.vue';
import { buttonClick, clickOnCard, copyID } from '@/view/profile/supportScript';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import defaultAvatar from '@/assets/themeFour/defaultAvatar.jpg';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter()
const statusRef = ref();
const userStore = useUserStore()
const name = computed(() => userStore.nickname)
const balance = computed(() => userStore.balance)
const id = computed(() => userStore.id)
const loadingRef = ref()
const currentLevel = computed(() => userStore.VIPData.currentLevel)
const avatarImg = computed(() => userStore.headimg)
const onCopyID = (id: any) => copyID(statusRef, id)
const onButtonClick = (type: string) => {
    if (type === 'withdraw') {
        router.push({ path: '/sd-withdraw' });
    } else if (type === 'topup') {
        router.push({ path: '/sd-topup' });
        localStorage.setItem('showDepositBackIcon', '1')
    }
}

async function refreshDetails() {
    try {
        loadingRef.value.open()
        await userStore.getInfo()
    } catch (e) {
        console.log(e);
    } finally {
        loadingRef.value.close()
    }
}
</script>
<style scoped>
.container {
    padding: 20px 10px;
    font-size: 13px;
    background:
        url('@/assets/themeFour/profile_top_bg.png') no-repeat top center,
        #024a49;
    background-size: 100% 60%, auto;
    border-radius: 0 0 15px 10px;
    position: relative;
}

.head_card img {
    width: 100%;
}

.avatar img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: .02667rem solid hsla(0, 0%, 100%, .25);
}

.value img {
    width: 25px;
    padding-left: 10px;
}


.notif {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
}

.notif img {
    width: 25px;
}

.unreadCount {
    color: #fff;
    background: red;
    border-radius: 10px;
    width: 15px;
    height: 15px;
    font-size: 12px;
    text-align: center;
    position: absolute;
    bottom: 15px;
    right: -8px;
}

@media (max-width:450px) {
    .content {
        margin: -39vw 0 1vh 0;
        padding: 0 15px;
    }
}

@media (min-width: 500px) {
    .content {
        margin: -22vh 0 6vh 0;
        padding: 0 15px;
        font-size: 2.1vh;
    }

    .head_card {
        padding-bottom: 0;
    }

    .button_container {
        font-size: 2.1vh;
    }
}

@media (min-width: 1440px) {
    .content {
        margin: -11vw 0 3vh 0;
        padding: 0 15px;
        font-size: 1vw;
    }

    .button_container {
        font-size: 1vw;
    }
}

@media (min-width: 1920px) {
    .content {
        margin: -9vw 0 6vh 0;
        padding: 0 15px;
        font-size: 1vw;
    }

    .head_card {
        padding-bottom: 0;
    }

    .button_container {
        font-size: 1vw;
    }
}

.mail {
    display: flex;
    justify-content: right;
}

.mail img {
    width: 30px;
    height: 32px;
}

.id {
    color: #fffefe66;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-bottom: 6px;
    padding-top: 0px;
}

.detailsContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 16px;
}

@media (max-width:380px) {
    .detailsContainer {
        padding-left: 20px;
        font-size: 14px;

    }

    .value img {
        width: 20px;
    }

    .value {
        font-size: 15px;

    }
}

.contact {
    color: #fff;
    align-items: center;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
}

.contact,
.id img {
    width: 25px;
    padding: 0px;
}

.level {
  position: relative;
  display: inline-block;
  width: 100%;
}


.level img {
    width: 4.5rem;
    padding-left: 5px;
    position: relative;
    display: inline-block;
}

.img-text {
    position: absolute;
    top: 40%;
    left: 215%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-weight: bold;
    font-size: 12px;
    white-space: nowrap;
}

.value {
    color: rgba(255, 255, 255, 0.65);
    font-size: 18px;

}

.value span {
    color: #fff;
    font-size: 14.25px;
}

.withdraw_btn {
    margin-top: 10px;
    padding: 5px;
}

.deposit_btn {
    margin-top: 10px;
    padding: 4px 5px;
}
.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.75);
    }

    100% {
        transform: scale(1);
    }
}

.top-row-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.balance-col {
    text-align: center;
    color: #fffefe66;
}

.withdraw-btn,
.deposit-btn {
    background: var(--ep-color-background-fill-surface-raised-L2);
    box-shadow: 0 -26px 20px -24px rgba(164, 159, 67, 0.4) inset;
    color: var(--ep-color-text-default);
    font-weight: bold;
    font-size: 15px;
}

.amount-sign {
    color: rgb(255, 154, 79) !important;
    font-size: 20px !important;
}

.amount-row {
    border-bottom: 1px solid rgb(0, 102, 99);
    padding-bottom: 0.7rem;
    padding-top: 1.2rem;
    margin-bottom: 0.3rem;
}
</style>